<article
  *ngIf="(isUnAuthenticated$ | async) && hasError"
  class="col-12 pt-1 pb-4 pl-3 pr-4 absolute top-0 w-7 h-1rem mt-1"
>
  <div class="flex flex-wrap justify-content-start align-items-top">
    <img
      id="prompt-logo-center"
      height="50"
      class="agility-logo"
      src="https://d27djv6oelqi3r.cloudfront.net/agility-logo-06.png"
      alt="Agility"
    />
  </div>
</article>

<section
  class="page-layout"
  [class.secure]="isAuthenticated$ | async"
  [class.public]="isUnAuthenticated$ | async"
  [class.public__wab]="
    environmentProfile === 'wab' && (isUnAuthenticated$ | async)
  "
  [class.error]="hasError"
  [class.banner]="bannerMessage.visible"
  [ngClass]="{ 'progress-spinner-full-page-opacity': startProgressSpinner }"
>
  <div *ngIf="isAuthenticationError$ | async">
    <!-- Router Outlet for displaying /error route when authentication error occurs -->
    <router-outlet></router-outlet>

    <article
      *ngIf="hasError"
      class="col-12 page-footer pt-1 pb-4 pl-3 pr-4 absolute bottom-0 w-7 h-1rem mb-1"
    >
      <app-footer></app-footer>
    </article>
  </div>

  <div
    *ngIf="isAuthenticated$ | async"
    class="app-grid-layout"
    [class.expanded]="isSidebarExpanded$ | async"
    [class.header-height-with-custom-tenant-message]="
      customTenantMessageVisibility$ | async
    "
  >
    <div *ngIf="startProgressSpinner" class="spinner-container">
      <app-agility-loading-spinner
        ariaLabel="Loading"
        dataTestId="app-loading-spinner"
      ></app-agility-loading-spinner>
    </div>
    <nav class="app-top-nav page-header">
      @if (bannerMessage.visible) {
        <div class="banner-message-container">
          <div class="banner-message-text">{{ bannerMessage.text }}</div>
          <i
            pTooltip="Dismiss"
            pTooltipPosition="left"
            class="pi pi-times banner-close-icon"
            tabindex="0"
            role="button"
            (click)="onCloseBannerMessage()"
            (keydown.enter)="onCloseBannerMessage()"
            data-testid="app-close-banner-message-button"
          ></i>
        </div>
      }
      <div class="header-container px-4">
        <app-header *ngIf="isAuthenticated$ | async"></app-header>
      </div>
    </nav>
    <aside class="app-left-nav">
      <app-left-sidebar-menu></app-left-sidebar-menu>
    </aside>
    <div
      class="app-content"
      [class.reporting]="isReportingPage"
      [class.header-height-with-custom-tenant-message]="
        customTenantMessageVisibility$ | async
      "
    >
      <router-outlet></router-outlet>
    </div>
    <footer class="app-footer">
      <app-footer></app-footer>
    </footer>
    <div
      *ngIf="showPermissionsBanner$ | async"
      class="app-permissions-banner"
      [class.expanded]="isSidebarExpanded$ | async"
    >
      <div class="center-content">
        <i class="pi pi-lock text-xs"></i>
        <span>{{ permissionService.banner }}</span>
        <i class="pi pi-lock text-xs"></i>
      </div>
      <p-button
        icon="pi pi-times"
        styleClass="close-icon text-white"
        variant="text"
        (click)="onClosePermissionsBanner()"
        (keydown.enter)="onClosePermissionsBanner()"
        tabindex="0"
        role="button"
        data-testid="app-close-permissions-banner-button"
      >
      </p-button>
    </div>
  </div>
</section>
<app-agility-toast></app-agility-toast>
<p-confirmdialog
  rejectButtonStyleClass="p-button-outlined"
  data-testid="app-confirm-dialog"
></p-confirmdialog>
<p-confirmdialog
  [style]="{ width: '29.25rem' }"
  key="inactivityDialog"
  (onHide)="onHideInactivityDialog()"
  data-testid="app-inactivity-dialog"
></p-confirmdialog>
